import Vue from 'vue';
import { REGION_URLS } from '@/assets/js/config';
import { getUser, changeActiveProject, getIdpTokens, getEmkToken } from '@/assets/js/api/current-user';
import { getCustomers } from '@/assets/js/api/customer';
import { getUnscopedToken, getScopedToken, getOpenstackDomainInfo, getProjectsByTeam } from '@/assets/js/api/openstack';
import { setTeamService, getAvailableServices } from '@/assets/js/api/team';
import { getTeamInvitations } from '@/assets/js/api/invitation';
import { getMessages } from '@/assets/js/api/message-center';
import { format } from 'date-fns';
import { getRefreshToken, tokensToLocalStorage } from '@/assets/js/auth';
import { getEmkCookies } from '@/assets/js/api/emk';
import { getIdToken } from '@/assets/js/auth';

export default Vue.mixin({
  data() {
      return {
          projectCounter: 0,
          regionUrls: REGION_URLS,
      }
  },
  methods: {
    async setUserData(newCurrentProject, reset) {
      getUser()
      .then((response) => {
        if (localStorage.getItem('team_services') != null) {
            this.checkTeamService(false, JSON.parse(localStorage.getItem('team_services')));
        }

        const userIdpData = getIdToken(true);

        this.$store.commit('user/HAS_DATA', true);
        if (response) {
            let user = {
                id: response.data.id,
                email_address: response.data.email_address,
                email_verified: userIdpData.email_verified,
                first_name: userIdpData.given_name != null ? userIdpData.given_name : '',
                last_name: userIdpData.family_name != null ? userIdpData.family_name : '',
                current_project: response.data.current_os_project,
                current_emk_project: response.data.current_emk_project,
                prefered_language: response.data.prefered_language,
                created_at: response.data.created_at,
                knowledge: response.data.knowledge,
                phone_number: response.data.phone_number,
                hasOS: response.data.espada_provider_foreign_id != null ? true : false
            }
            if (reset) {
                user.current_project = null;
                localStorage.removeItem('current_namespace');
                localStorage.removeItem('current_team_id');
                localStorage.removeItem('customer_id');
                localStorage.removeItem('current_project');
                this.$store.commit('misc/PAGE_LOADING', true);
            } else if (newCurrentProject) {
                user.current_project = newCurrentProject;
                localStorage.removeItem('current_namespace');
            } else if (response.data.current_os_project != null && response.data.current_os_project.fra == null) {
                user.current_project = null;
                if (response.data.current_emk_project) {
                    localStorage.setItem('current_namespace' , response.data.current_emk_project);
                }
            }

            this.$store.dispatch('user/PATCH_INFO', user);

            if (response.data.os_provider_foreign_id != null) {
                this.$store.commit('misc/HAS_AMS2', true);
            }

            if (response.data.provider_foreign_id != null) {
                this.$store.commit('misc/HAS_AMS1', true);
            }
            this.$store.commit('misc/SET_ACTIVE_REGION', 'ams2');

            if (response.data.teams.length === 0) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'registered'
                });
            } else {
                if (response.data.teams.length === 1) {
                    this.checkTeamService(response.data.teams[0]);
                }
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'registered'
                });
                if (typeof window.lintrk === 'function') {
                    window.lintrk('track', { conversion_id: 6043188 });
                }
            }
            if (newCurrentProject) {
                localStorage.setItem('current_project', JSON.stringify(newCurrentProject));
                this.currentProjectSet(response.data.teams);
            } else {
                if (response.data.current_os_project != null && response.data.current_os_project.fra != null) {
                    localStorage.setItem('current_project', JSON.stringify(response.data.current_os_project));
                    this.currentProjectSet(response.data.teams);
                } else {
                    localStorage.removeItem('current_team_id');
                    localStorage.removeItem('region_tokens');
                    localStorage.removeItem('current_project');
                    localStorage.removeItem('services');
                    this.collectTeams(response.data.teams);
                }
            }
        }
      })
      .catch((error) => {
        console.error(error);
        this.showNotification('error', 'Fetching your profile data has failed');
      });
    },

    async checkTeamService(currentTeam, localStorageServices) {
        let serviceData = false;
        if (localStorageServices) {
            serviceData = localStorageServices;
        } else if (currentTeam.services && currentTeam.services.length > 0) {
            let arrayData = []
            currentTeam.services.forEach((item) => {
                arrayData.push(item.name);
            })
            serviceData = arrayData;
        }
        // ['CLOUD', 'EMK', 'OBJECTSTORE']

        if (serviceData) {
            localStorage.setItem('team_services', JSON.stringify(serviceData));
            if(serviceData.indexOf('EMK') !== -1) {
                this.$store.commit('misc/SET_EMK', true);
                if (currentTeam && this.hasEMKAccess && currentTeam.emk_projects.length > 0) {
                    await this.fetchEmkToken();
                } else {
                    this.$store.commit('emk/TEAM_HAS_NAMESPACE',  false);
                }
            } else {
                this.$store.commit('misc/SET_EMK', false);
            }

            if(serviceData.indexOf('CLOUD') !== -1) {
                this.$store.commit('misc/SET_CLOUD', true);
            } else {
                this.$store.commit('misc/SET_CLOUD', false);
            }

            if(serviceData.indexOf('OBJECTSTORE') !== -1) {
                this.$store.commit('misc/SET_OBJECTSTORE', true);
            } else {
                this.$store.commit('misc/SET_OBJECTSTORE', false);
            }
        } else {
            localStorage.removeItem('team_services');
        }

        if (currentTeam) {
            this.$store.commit('misc/PAGE_LOADING', false);
        }
        if(localStorage.getItem('isFuga') != null && typeof Notification.requestPermission() !== 'undefined') {
            Notification.requestPermission().then((result) => {
                if (result === 'default') {
                      Notification.requestPermission();
                }
            });
        }
        this.fetchMessages();
    },

    async fetchEmkToken() {
        getEmkToken()
        .then((response) => {
            this.fetchEmkCookies(response.data.access_token);
        })
        .catch((error) => {
            this.showNotification('error', `Fetching EMK token has failed`);
            console.error(error);
        });
    },

    async fetchEmkCookies(accessToken) {
        getEmkCookies(accessToken)
        .then((response) => {
            setTimeout(() => {
                this.fetchAllEMkResources();
                this.$store.commit('emk/TEAM_HAS_NAMESPACE',  true);
                this.setEmkProject();
            }, 1000);
        })
        .catch((error) => {
            this.showNotification('error', `Fetching EMK token has failed`);
            console.error(error);
        });
    },

    async setTeamServices(serviceId) {
          setTeamService(serviceId)
          .then((response) => {
          })
          .catch((error) => {
              this.showNotification('error', `ERROR TEAM Service`);
              console.error(error);
          });
    },

    async currentProjectSet(teams) {
        this.$store.commit('project/HAS_DATA', true);
        let showCards = false;
        if (localStorage.getItem('show_cards') === 'true') {
          showCards = true;
        }
        this.$store.commit('misc/SHOW_CARDS', showCards);
        this.collectTeams(teams);
    },

    async collectTeams(teams) {
        if (teams.length > 0) {
          this.$store.dispatch('team/SET', teams);

          let teamsWithForeignId = this.$store.state.team.info.filter(post => {
              if (typeof post.espada_provider_foreign_id === 'string') {
                  return post;
              }
          })

          if (teamsWithForeignId.length === 0) {
              if (this.deployingEnvironment) {
                  this.setUserData();
                  return;
              }
              this.$store.commit('team/HAS_DATA', true);
              this.$store.dispatch('team/SET_CURRENT', teams[0]);
              localStorage.setItem('current_team_id', teams[0].id);
              if (teams[0].customer) {
                  this.setCustomerData();
              }
          } else {
              this.fetchProjectsByTeam(teamsWithForeignId);
          }
        } else {
            localStorage.removeItem('current_team_id');
            localStorage.removeItem('customer_id');
            this.$store.commit('misc/PAGE_LOADING', false);
        }
        this.$store.commit('team/UPDATE_KEY');
    },

    async fetchProjectsByTeam(teamsWithForeignId) {
        const requestPromises = [];
        let currentProject = JSON.parse(localStorage.getItem('current_project'));
        if (currentProject == null) {
            currentProject = this.$store.state.user.info.current_project;
        }
        teamsWithForeignId.forEach((team) => {
            const promise = getProjectsByTeam(team.id)
            .then((response) => {
                let teamData = response.data;
                teamData.id = team.id;
                teamData.os_domain_id = response.data.os_domain_id;
                teamData.active = false;
                this.$store.commit('team/UPDATE', teamData);
                return teamData;
            })
            requestPromises.push(promise);
        })

        Promise.all(requestPromises)
        .then((response) => {
            this.fetchingProjectSuccessful(response);
        });
    },

    fetchingProjectSuccessful(response, error) {
        let currentProject = JSON.parse(localStorage.getItem('current_project'));
        if (currentProject == null) {
            currentProject = this.$store.state.user.info.current_project
        }
        if (currentProject != null) {
            let currentTeam = false;
            this.$store.state.team.info.forEach((team, i) => {
                if (team.projects) {
                    team.projects.forEach((project, i) => {
                          if (project.id === currentProject.id) {
                                currentTeam = team;
                          }
                    });
                }
            });
            if (currentTeam == undefined || error) {
                this.$store.dispatch('team/SET_CURRENT', this.$store.state.team.info[0]);
                localStorage.setItem('current_team_id', this.$store.state.team.info[0].id);
                this.checkTeamService(this.$store.state.team.info[0]);
            } else {
                let data = {
                  'user': this.$store.state.user.info,
                  'team': currentTeam
                }
                this.$store.dispatch('team/SET_CURRENT', currentTeam);
                this.$store.commit('user/SET_ROLES', data);
                localStorage.setItem('current_team_id', currentTeam.id);
                this.checkTeamService(currentTeam);

                let currentProject = false;
                // Object.entries(this.$store.state.team.info.current_project).forEach(([key, value]) => {
                //       console.log('KP ' , value , ' keys: ', key,)
                //       if (key === localStorage.getItem('current_project_name')) {
                //         console.log('KP LOCAL EN KYE KLOPPEN')
                //           currentProject = value
                //       }
                // })

                if (currentProject) {
                  this.$store.dispatch('project/SET', currentProject);
                  this.fetchOpenstackDomainInfo();
                }
            }
        } else {
          let teams = this.$store.state.team.info;
          this.$store.dispatch('team/SET_CURRENT', teams[0]);
          localStorage.setItem('current_team_id', teams[0].id);
          if(teams[0].projects) {
              teams[0].active = true;
              let projectName = Object.keys(teams[0].projects)[0];
              localStorage.setItem('current_project', JSON.stringify(this.createCurrentProjectObject(teams[0].projects[projectName])));
              this.$store.commit('misc/SET_ACTIVE_REGION', teams[0].projects[projectName].region_id);
              this.$store.dispatch('project/SET', teams[0].projects[projectName]);
              this.changeActiveProject(teams[0].projects[projectName]);
              this.checkTeamService(teams[0]);
          }
        }
        this.setActiveProject();
    },

    async setActiveProject() {
        this.$store.commit('project/HAS_DATA', true);
        this.$store.commit('team/HAS_DATA', true);
        this.$store.commit('misc/HAS_TENANT', true);
        this.$store.commit('team/SWITCHING_TEAM', false);
        this.$store.commit('misc/DEPLOYING_ENVIRONMENT', false);
        this.$store.commit('misc/DEPLOYING_NEW_TEAM', false);
        this.$store.commit('team/SWITCHING_TEAM', false);
        this.setCustomerData();
        localStorage.removeItem('usage');
        let monthData = format(new Date(), 'L');
        let yearData = format(new Date(), 'yyyy');
        this.fetchCurrentMonthUsage(yearData, monthData);
        this.$store.commit('misc/PAGE_LOADING', false);
        this.checkTokens();
        if (localStorage.getItem('show_cards') === 'true') {
            this.$store.commit('misc/SHOW_CARDS', true);
        }
    },

    async pollProjectStatus(projectId) {
        let handle = setInterval(() => {
            let currentTeam = this.$store.state.team.current;
            getProjectsByTeam(currentTeam.id)
            .then((response) => {
                let data = false;
                if (!projectId) {
                    if (response.data.projects && response.data.projects[0] && response.data.projects[0].provs && response.data.projects[0].provs.length > 0) {
                        data = response.data.projects[0].provs.filter(item => !item.os_id);
                    }
                    if (data && data.length === 0) {
                        clearInterval(handle);
                        this.showNotification('success', 'Cloud environment created. Retrieving data..');
                        localStorage.removeItem('tempProjectName');
                        setTimeout(() => {
                            if (this.$store.state.user.info.hasOS) {
                                response.data.projects[0].name
                                let newProjectData = this.createCurrentProjectObject(response.data.projects[0]);
                                localStorage.setItem('current_project', JSON.stringify(newProjectData));
                                this.setUserData(newProjectData);
                            } else {
                                this.refreshToken();
                            }
                            if (this.$router.currentRoute.name !== 'team') {
                                this.$router.push({ name: 'team' });
                            } else {
                                this.$router.push({ name: 'home' });
                            }
                        }, 2000);
                    }
                } else {
                    let project = response.data.projects.find(item => item.id === projectId)
                    if (project && project.provs && project.provs.length > 0) {
                        data = project.provs.filter(item => !item.status.includes('ACTIVE'));
                    }
                    if (data && data.length === 0) {
                        clearInterval(handle);
                        setTimeout(() => {
                            this.setUserData();
                            this.showNotification('success', 'Project is ready for use');
                        }, 2000);
                    }
                }
            })
            .catch((error) => {
                if (error.response != undefined) {
                    clearInterval(handle);
                    this.showNotification('error', `Cloud environment not created. Please contact support.`);
                    setTimeout(() => {
                        window.location = '/';
                    }, 2000);
                }
            });
        }, 3000);
    },

    async refreshToken(newProjectData) {
        let refreshToken = getRefreshToken()
        await getIdpTokens(false, refreshToken)
        .then((response) => {
            tokensToLocalStorage(response.data);
            setTimeout(() => {
                this.setUserData(newProjectData);
            }, 2000);
        })
    },

    // TOKENS CHECK
    checkTokens() {
        if (localStorage.getItem('region_tokens')  == null) {
            setTimeout(() => {
                this.fetchOpenstackToken();
            }, 5000);
        } else {
            let dateNow = new Date().getTime();
            let tokenDate = JSON.parse(localStorage.getItem('region_tokens'))[0].expiredAt;
            tokenDate =  new Date(tokenDate).getTime();
            // let tokenDate = "2023-06-28T22:20:42.000Z";
            dateNow = new Date().getTime();
            // check current project is same as endpoint projectId
            let volumeEndpoints = JSON.parse(localStorage.getItem('services')).volumev3;
            let region = localStorage.getItem('selected_region') ? JSON.parse(localStorage.getItem('selected_region'))[0] : 'core';
            let volumeEndpoint = volumeEndpoints[region];
            // if (volumeEndpoint) {
            //     region = 'core';
            //     volumeEndpoint = volumeEndpoint[region];
            //     console.log('volumeEndpoint', volumeEndpoint)
            // }
            let projectId = JSON.parse(localStorage.getItem('current_project'))[region];
            let currentProject = volumeEndpoint.includes(projectId);
            if (tokenDate < dateNow || !currentProject) {
                setTimeout(() => {
                    this.fetchOpenstackToken();
                }, 5000);
            } else {
                this.getServices(JSON.parse(localStorage.getItem('services')));
            }
        }
    },

    async fetchOpenstackToken() {
        const requestPromises = [];
        let selectRegions = localStorage.getItem('selected_region') ? JSON.parse(localStorage.getItem('selected_region')) : false;
        if (selectRegions) {
            let newData = []
            selectRegions.forEach((region) => {
                let singleRegionUrl = this.regionUrls[selectRegions]
                if (singleRegionUrl) {
                    newData.push(singleRegionUrl)
                }
            });
            this.regionUrls = newData;
        }
        Object.keys(this.regionUrls).forEach((key) => {
            const promise =  getUnscopedToken(this.regionUrls[key], false)
            .then((response) => {
                return response;
            })
            requestPromises.push(promise);
        })
        Promise.allSettled(requestPromises)
        .then(response => {
            let successFullResponses  = response.filter(item => item.status !== 'rejected')
            if (successFullResponses) {
                this.fetchScopedToken(successFullResponses);
            }
        });
    },

    async fetchScopedToken(responseData) {
        const requestPromises = [];
        responseData.forEach((scopedTokenData) => {
            let projectName = ''
            if (this.$store.state.user.info.current_project) {
              projectName = this.$store.state.user.info.current_project.name
            } else {
              projectName = JSON.parse(localStorage.getItem('current_project')).name
            }
            const promise = getScopedToken(scopedTokenData.value.headers['x-subject-token'], scopedTokenData.value.config.url.split('/OS-FEDE')[0], projectName, this.$store.state.team.current.os_domain_id)
            .then((response) => {
                return response;
            })
            requestPromises.push(promise);
        })
        Promise.allSettled(requestPromises)
            .then(response => {
              let successFullResponses  = response.filter(item => item.status !== 'rejected')
                if (successFullResponses && successFullResponses[0]) {
                    this.setServicesFromToken(successFullResponses);
                    let tokenData = [];
                    let userData = [];
                    successFullResponses.forEach((regionData, i) => {
                        let regionName = regionData.value.config.url.split('//')[1].split('.')[0];
                        let regionToken = regionData.value.headers['x-subject-token'];
                        let ExpiryDate = new Date(regionData.value.data.token.expires_at);
                        let data = {
                            'name': regionName,
                            'token' : regionToken,
                            'expiredAt': ExpiryDate,
                        };
                        tokenData.push(data);
                        let userSingleData = {'name' : [regionName][0], 'id' : regionData.value.data.token.user.id};
                        userData.push(userSingleData);
                        // localStorage.setItem('user_id', successFullResponses[0].value.data.token.user.id);
                    });
                    localStorage.setItem('region_tokens', JSON.stringify(tokenData));
                    localStorage.setItem('user_id', JSON.stringify(userData));
                } else {
                    this.showNotification('error', `Start session went wrong. Please reload the page. If reloading the page is not working please login again.`);
                }
            });
      },


    async setServicesFromToken(data) {
        const requestPromises = [];
        let services = {};
        data.forEach((regionServiceData) => {
            const promise = this.parseServiceData(regionServiceData)
            .then((response) => {
                return response;
            })
            requestPromises.push(promise);
        })
        Promise.all(requestPromises)
        .then((response) => {
          this.updateAfterServices(response);
        });
    },

    async parseServiceData(regions) {
        let regionServices = {};
        regions.value.data.token.catalog.forEach((service, index) => {
            let serviceEndpoint =  service.endpoints.find(item => item.interface === 'public');
            if (serviceEndpoint != undefined) {
              let regionName = serviceEndpoint.url.split('://')[1].split(':')[0].split('.')[0];
              if (serviceEndpoint != undefined && service.type !== 'identity') {
              // if (serviceEndpoint != undefined && service.type !== 'object-store' && service.type !== 'identity') {
                  if(serviceEndpoint.url.substr(-1) === '/') {
                      regionServices[service.type] = serviceEndpoint.url.substr(0, serviceEndpoint.url.length - 1);
                  } else {
                      regionServices[service.type] = serviceEndpoint.url;
                  }
              } else if (serviceEndpoint != undefined && service.type === 'identity') {
                  regionServices['identity'] = serviceEndpoint.url + '/v3';
              }
              if (serviceEndpoint != undefined && service.type === 'object-store') {
                  let url = serviceEndpoint.url.split(":8080");
                  if (localStorage.getItem('current_project') != undefined) {
                      let projectId = JSON.parse(localStorage.getItem('current_project'))[serviceEndpoint.region]
                      if (projectId) {
                          regionServices.s3 = url[0] + ':8080/' + projectId;
                      }
                  }
              }
            }
        })
        return regionServices
    },

    updateAfterServices(services) {
          // krijg het volgende terug:
          // "dns": {
          //   'ams': "https://stagingamstwo.fuga.cloud:9001"
          //   'fra': "https://stagingamstwo.fuga.cloud:9001"
          // },
          let regionServices = {};
          services.forEach((singleRegionData, i) => {
              let regionName = singleRegionData.compute.split('.')[0].split('://')[1];
              Object.keys(singleRegionData).forEach((key) => {
                regionServices[key] = regionServices[key] || {};
                regionServices[key][regionName] = singleRegionData[key]
              });
          });
          localStorage.setItem('services', JSON.stringify(regionServices));
          this.getServices(regionServices);
          this.$store.commit('misc/PAGE_LOADING', false);
          this.$store.commit('services/HAS_DATA', true);
          this.$store.commit('misc/DEPLOYING_ENVIRONMENT', false);
          this.$store.commit('misc/DEPLOYING_NEW_TEAM', false);
    },

    getServices(services) {
        this.$store.commit('services/SET', services);
        // HAS TOKEN
        this.$store.commit('services/HAS_DATA', true);
    },
    // END TOKENS CHECK

    async setTeamData(callback) {
        let teams = this.$store.state.team.info;
        this.$store.commit('team/HAS_DATA', true);
        this.$store.dispatch('team/SET_CURRENT', teams[0]);
        localStorage.setItem('current_team_id', teams[0].id);
        this.setCustomerData();
    },

    // CUSTOMERS
    async setCustomerData() {
        let data = this.$store.state.team.current.customer;
        let customers = [];
        this.$store.state.team.info.forEach((item) => {
            customers.push(item.customer);
        });

        if (customers[0] != null) {
            // Filter duplicates
            let customerData = customers.filter((v,i,a)=>a.findIndex(t=>(t.id === v.id))===i)
            this.$store.commit('customer/SET_LIST', customerData);

            if (data != undefined && typeof data.name === 'string') {
              this.$store.commit('misc/PAGE_LOADING', false);
              localStorage.setItem('customer_id', data.id);
              this.$store.commit('customer/HAS_DATA', true);
              this.$store.dispatch('customer/SET_INFO', data);
              this.$store.dispatch('customer/ADD_COUNTRY_NAME', data.country);
            }
        } else {
            this.getCustomerData();
        }
    },

    async getCustomerData() {
      await getCustomers()
      .then((response) => {
        let data = {};
        if (response) {
          data = response.data[0];
        }

        if (data != undefined && typeof data.name === 'string') {
          this.$store.commit('misc/PAGE_LOADING', false);
          localStorage.setItem('customer_id', data.id);
          this.$store.commit('customer/HAS_DATA', true);
          this.$store.dispatch('customer/SET_INFO', data);
          this.$store.dispatch('customer/ADD_COUNTRY_NAME', data.country);
        }
      })
      .catch((error) => {
        console.error(error);
        this.showNotification('error', 'Fetching your data has failed');
      });
    },
    // END CUSTOMERS

    async changeCurrentProject(project) {
        let newProjectData = this.createCurrentProjectObject(project);
        let currentProject = JSON.parse(localStorage.getItem('current_project')).name;
        if(currentProject.name !== project.name) {
            // to do meer dan ID in current_project local storage
            localStorage.setItem('current_project', JSON.stringify(newProjectData));
            this.unsubscribeShoots();
            this.changeActiveProject(false, null);
            this.changeActiveProject(project, null);
            this.$store.dispatch('project/SET', project);

            this.$store.commit('misc/SET_ACTIVE_REGION', project.region_id);
            if (this.$router.currentRoute.name === 'volume') {
              this.$router.push({ name: 'volume-store' });
            }
            localStorage.removeItem('region_tokens');
            this.$store.commit('team/SWITCHING_TEAM', true);
            this.$store.commit('misc/HAS_TENANT', false);
            this.$store.commit('project/HAS_DATA', false);
            this.$store.commit('customer/HAS_DATA', false);
            this.$store.commit('team/HAS_DOMAIN_INFO', false);
            this.$store.commit('team/UPDATE_KEY');
            this.$store.commit('user/HAS_DATA', false);
            this.$store.dispatch('user/PATCH_INFO', []);
            this.$store.commit('usage/HAS_DATA', false);
            this.$store.dispatch('usage/UPDATE_CURRENT_MONTH', {});
            this.$store.dispatch('usage/UPDATE_SELECTED_MONTH', {});

            this.$store.dispatch('az/SET', []);
            this.$store.commit('az/IS_LOADING', true);
            this.$store.dispatch('backup/SET', []);
            this.$store.commit('backup/IS_LOADING', true);
            this.$store.commit('credential/SET', []);
            this.$store.commit('credential/IS_LOADING', true);
            this.$store.commit('databases/SET', []);
            this.$store.commit('databases/IS_LOADING', true);
            this.$store.commit('dns/SET', []);
            this.$store.commit('emk/SET',  []);
            this.$store.commit('dns/IS_LOADING', true);
            this.$store.dispatch('image/SET', []);
            this.$store.commit('image/IS_LOADING', true);
            this.$store.dispatch('instance/SET', []);
            this.$store.commit('instance/SET_QUOTA', false);
            this.$store.commit('instance/IS_LOADING', true);
            this.$store.commit('instance/SET_CONSOLE', false);
            this.$store.dispatch('ip/SET', []);
            this.$store.commit('ip/IS_LOADING', true);
            this.$store.commit('keyPair/SET', []);
            this.$store.commit('keyPair/IS_LOADING', true);
            this.$store.dispatch('kubernetes/SET_TEMPLATES', []);
            this.$store.commit('kubernetes/TEMPLATE_IS_LOADING', true);
            this.$store.dispatch('kubernetes/SET', []);
            this.$store.commit('kubernetes/IS_LOADING', true);
            this.$store.dispatch('listener/SET', []);
            this.$store.commit('listener/IS_LOADING', true);
            this.$store.dispatch('loadBalancer/SET', []);
            this.$store.commit('loadBalancer/IS_LOADING', true);
            this.$store.dispatch('lbMember/SET', []);
            this.$store.commit('lbMember/IS_LOADING', true);
            this.$store.dispatch('network/SET', []);
            this.$store.commit('network/IS_LOADING', true);
            this.$store.commit('network/SET_QUOTA', false);
            this.$store.commit('objectStore/HAS_DATA', false);
            this.$store.commit('objectStore/IS_LOADING', true);
            this.$store.commit('objectStore/SET', []);
            this.$store.commit('objectStore/HAS_DETAILS', false);
            this.$store.commit('objectStore/HAS_OBJECTS', false);
            this.$store.commit('osCredentials/HAS_DATA', false);
            this.$store.commit('osCredentials/SET', []);
            this.$store.dispatch('pool/SET', []);
            this.$store.commit('pool/IS_LOADING', true);
            this.$store.dispatch('port/SET', []);
            this.$store.commit('port/IS_LOADING', true);
            this.$store.dispatch('router/SET', []);
            this.$store.commit('router/IS_LOADING', true);
            this.$store.dispatch('securityGroup/SET', []);
            this.$store.commit('securityGroup/IS_LOADING', true);
            this.$store.dispatch('services/SET', []);
            this.$store.commit('services/HAS_DATA', false);
            this.$store.dispatch('snapshot/SET', []);
            this.$store.commit('snapshot/IS_LOADING', true);
            this.$store.dispatch('subnet/SET', []);
            this.$store.commit('subnet/IS_LOADING', true);
            this.$store.commit('volumev3/SET', []);
            this.$store.commit('volumev3/IS_LOADING', true);
            this.$store.commit('volumev3/SET_QUOTA', false);
            this.setUserData(newProjectData);
        }
        if (this.$router.currentRoute.name !== 'team') {
            this.$router.push({ name: 'team' });
        }
    },

    async changeActiveProject(osProject, EMKNamespace, changeNoData, refreshToken) {
        let projectData = {}
        let noDBChange = false;
        if (changeNoData) {
            projectData.current_os_project = osProject;
        } else if (osProject) {
            let convertedProjectData = this.createCurrentProjectObject(osProject);
            localStorage.setItem('current_project', JSON.stringify(convertedProjectData));
            projectData.current_os_project = convertedProjectData;
            let projectsIsNull = Object.values(convertedProjectData).filter(item => item === null)
            if(projectsIsNull.length > 0) {
                noDBChange = true;
            }
        }
        if (EMKNamespace) {
            projectData.emk_namespace = EMKNamespace;
        }
        if (!noDBChange) {
            changeActiveProject(projectData)
            .then(() => {
                if (refreshToken) {
                    this.refreshToken(JSON.parse(localStorage.getItem('current_project')));
                }
            })
            .catch((error) => {
                console.error(error);
            });
        }
    },

    async fetchTeamInvitations(otherTeamId) {
        getTeamInvitations(otherTeamId)
        .then((response) => {
            this.$store.dispatch('team/SET_INVITATIONS', response.data);
        })
        .catch((error) => {
            console.error(error);
            this.showNotification('error', 'Fetching your invitations has failed');
        });
    },

    async fetchOpenstackDomainInfo() {
        getOpenstackDomainInfo()
        .then((response) => {
            this.$store.commit('team/ADD_DOMAIN_DATA', response.data);
            this.$store.commit('team/HAS_DOMAIN_INFO', true);
        })
        .catch((error) => {
            console.error(error);
        });
    },

    fetchTeamServices() {
        getAvailableServices()
        .then((response) => {
            this.$store.commit('team/SET_AVAILABLE_SERVICES', response.data);
            this.$store.commit('team/UPDATE_KEY');
        })
        .catch((error) => {
            console.error(error);
        });
    },

    createCurrentProjectObject(project) {
        let newProjectData = {}
        if (project.provs && project.provs.length > 0) {
            project.provs.forEach((projectData, i) => {
                newProjectData[projectData.region_name] = projectData.os_id;
            });
        }
        newProjectData.name = project.name;
        newProjectData.id = project.id;
        return newProjectData;
    },

    setEmkProject() {
        let currentTeam = this.$store.state.team.current;
        if (localStorage.getItem('current_namespace') != null) {
            let cleanNameSpaceName = localStorage.getItem('current_namespace').split('garden-')[1];
            if (currentTeam.emk_projects && currentTeam.emk_projects.length > 0 && currentTeam.emk_projects.filter(item => item.provider_foreign_name === cleanNameSpaceName).length === 0) {
                let nameSpaceName = 'garden-' + currentTeam.emk_projects[0].provider_foreign_name;
                localStorage.setItem('current_namespace', nameSpaceName)
                this.changeActiveProject(false, nameSpaceName);
            } else if (currentTeam.emk_projects && currentTeam.emk_projects.length === 0) {
                localStorage.removeItem('current_namespace')
                this.changeActiveProject(false, null);
            }
        } else {
            if (currentTeam.emk_projects && currentTeam.emk_projects.length > 0) {
                let nameSpaceName = 'garden-' + currentTeam.emk_projects[0].provider_foreign_name;
                localStorage.setItem('current_namespace', nameSpaceName)
                this.changeActiveProject(false, nameSpaceName);
            }
        }
    },

    async fetchMessages() {
        let customerId = localStorage.getItem('customer_id');
        let teamId = localStorage.getItem('current_team_id');
        let userId = this.$store.state.user.info.id;
        // don't trigger getMessages when all are undefined
        if (!customerId && !teamId && !userId) {return}
        getMessages(customerId, teamId, userId)
        .then((response) => {
            let text = {}
            text.update_customer = []
            text.update_customer.push('Please check if your billing details are still up to date. We have the following information:');

            text.onboarding = []
            text.onboarding.push('A few days ago you started our registration process. The process is just not complete yet. Is there anything I can help you with to ensure that you can start using our fast, stable and reliable services? After all, we are the Dutch Cloud for a reason :)');
            text.onboarding.push('Problems with the payment or payment method?');
            text.onboarding.push("Payment is easy with us and can be done in various ways. We accept, among others, Credit Cards (Visa, MasterCard) and SEPA Direct Debit (direct debit). We don't charge any startup costs or hidden extras, you only pay for the products you actually use. In the dashboard you can view your usage in euros at all times, so you are not faced with unexpected surprises and you are in control of the costs.");
            text.onboarding.push('Safety, clarity and distinctness are our top priorities. In addition to being completely Dutch, we have various certifications and we try to keep our support level as high as possible. If you miss something about our services, we would like to hear from you so that we can still be of service.');

            text.soft_limit = []
            text.soft_limit.push("Your team's usage exceeds the soft limit you set at €.");
            text.soft_limit.push("Check your team's usage.");

            let customerName = this.$store.state.customer.info.name;

            let data = response.data.filter(item => item.type === 'update_customer');
            // response.data.forEach((message, i) => {
            data.forEach((message, i) => {
                if (message.type === 'update_customer') {
                    message.sender = 'Marino';
                    message.title = `Are your billing details of ${ customerName } still correct?`;
                    message.linkName = 'billing';
                    message.linkText = 'Go to your billing details';
                // } else if (message.type === 'onboarding') {
                //     message.sender = 'Marino';
                //     message.title = `Complete your registration within 1 minute`;
                //     message.linkName = 'billing';
                //     message.linkText = 'Complete registration';
                //     message.onboarding = true;
                } else if (message.type === 'update_customer_dummy') {
                    message.sender = 'Yuri';
                    message.title = 'Your usage exceeds your soft limit';
                    message.linkName = 'team';
                    message.linkText = 'Go to your soft limit settings';
                }
                message.text = text[message.type]
            });
            this.$store.commit('notification/SET', data);
        })
        .catch((error) => {
            console.error(error);
            this.showNotification('error', 'Fecthing messages has failed');
        });
    },
  },
});
